import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-align_bottom_fill",
  "use": "icon-align_bottom_fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-align_bottom_fill\">\n  <path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n  <path d=\"M6,16.56l12-.06V18H6ZM10,12h2L9,15,6,12H8V5h2Zm6,0h2l-3,3-3-3h2V5h2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol